export const gridCellCounts= [1, 2, 4, 6, 9, 12]

export const gridColumnVariants = {
  1: 'grid-cols-1',
  2: 'grid-cols-1',
  4: 'grid-cols-2',
  6: 'grid-cols-2',
  9: 'grid-cols-3',
  12: 'grid-cols-3',
}

export const gridCellOptions = Array.from(gridCellCounts, (count) => {
  return {
    count: count,
    text: Drupal.formatPlural(count, '1 square', '@count squares')
  }
})
